module.exports = __webpack_public_path__ + "media/images/admin/icons/grid-8a18c96e230091fc1a0954064843d30f.svg";